import INVENTORY_API_BASE_URL from "../../config/api";








  












import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Axios from "axios";
import { CSVLink } from "react-csv";

function SearchFilter() {
  const [listOf, setlistOf] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  
  const navigate = useNavigate();

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      setlistOf(response.data);
      setFilteredData(response.data);
    });
  }, []);



  const handleEditForm = (formId) => {
    const form = listOf.find((form) => form._id === formId);
    if (form) {
      navigate("/Createlisting", { state: { form, isEditing: true } });
    }
  };



  useEffect(() => {
    const filteredList = listOf.filter(
      (form) =>
        form.sku.toLowerCase().includes(filterText.toLowerCase()) ||
        form.title.toLowerCase().includes(filterText.toLowerCase())
    );
    setFilteredData(filteredList);
  }, [filterText, listOf]);
  

  const handleStatusFilter = (status) => {
    setSelectedStatus(status);
    if (status === "") {
      setFilteredData(listOf);
    } else {
      const filteredList = listOf.filter((form) => form.AuthStatus === status);
      setFilteredData(filteredList);
    }
  };

  const dataToExport = filteredData.map((form, index) => ({
    index: index + 1,
    ...form,
  }));

  const csvHeaders = [
    { label: "S.N", key: "index" },
    { label: "SKU", key: "sku" },
    { label: "Title", key: "title" },
    { label: "Medium", key: "Medium" },
    { label: "Edition", key: "edition" },
    { label: "Weight(g)", key: "weight" },
    { label: "Coins", key: "stock" },
    
    { label: "Publishing-Date", key: "date" },
    
    
    { label: "Status", key: "AuthStatus" },
    
    { label: "MRP", key: "mrp" },
  ];



  function formatDate(date) {
    if (!date) return "Invalid Date"; 
    
    let parsedDate;
  
    
    if (/\d{2}-\d{2}-\d{4}/.test(date)) {
      const [day, month, year] = date.split("-");
      parsedDate = new Date(`${year}-${month}-${day}`);
    } else {
     
      parsedDate = new Date(date);
    }
  
    
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().slice(0, 10).replace(/-/g, "/");
    } else {
      return "Invalid Date";
    }
  }

  return (
    <section className="listing-catalog" aria-label="Book listings">
      <div className="listing-catalog__summary" aria-label="Listing totals">
        <div className="listing-catalog__summary-heading">
          <span className="listing-catalog__summary-label">CATALOG SNAPSHOT</span>
          <strong>{listOf.length.toLocaleString()} listings</strong>
          <span className="listing-catalog__summary-caption">Current inventory records</span>
        </div>
        <div className="listing-catalog__metrics">
          <div className="listing-catalog__metric listing-catalog__metric--active">
            <span className="listing-catalog__metric-dot" aria-hidden="true" />
            <span>Active</span>
            <strong>{listOf.filter((form) => form.AuthStatus === "active").length}</strong>
          </div>
          <div className="listing-catalog__metric listing-catalog__metric--inactive">
            <span className="listing-catalog__metric-dot" aria-hidden="true" />
            <span>Inactive</span>
            <strong>{listOf.filter((form) => form.AuthStatus === "inactive").length}</strong>
          </div>
          <div className="listing-catalog__metric listing-catalog__metric--upcoming">
            <span className="listing-catalog__metric-dot" aria-hidden="true" />
            <span>Upcoming</span>
            <strong>{listOf.filter((form) => form.AuthStatus === "upcoming_books").length}</strong>
          </div>
        </div>
      </div>

      <div className="listing-catalog__toolbar">
        <label className="listing-search">
          <svg className="listing-search__icon" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="10.8" cy="10.8" r="6.8" />
            <path d="m16 16 4.5 4.5" />
          </svg>
          <input
            type="search"
            placeholder="Search by SKU or title"
            aria-label="Search listings by SKU or title"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
          {filterText && (
            <button
              className="listing-search__clear"
              type="button"
              onClick={() => setFilterText("")}
              aria-label="Clear search"
            >
              ×
            </button>
          )}
        </label>
        <CSVLink
          className="listing-export"
          data={dataToExport}
          headers={csvHeaders}
          filename="Listing.csv"
        >
          <svg className="listing-export__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3v11m0 0 4-4m-4 4-4-4" />
            <path d="M5 15v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
          </svg>
          Export CSV
        </CSVLink>
      </div>

      <div className="listing-catalog__filters" role="group" aria-label="Filter listings by status">
        <span className="listing-catalog__filters-label">Status</span>
        <label className={"listing-filter" + (selectedStatus === "" ? " is-selected" : "")}>
          <input
            type="radio"
            name="listingStatus"
            value=""
            checked={selectedStatus === ""}
            onChange={() => handleStatusFilter("")}
          />
          <span>All listings</span>
          <span className="listing-filter__count">{listOf.length}</span>
        </label>
        <label className={"listing-filter listing-filter--active" + (selectedStatus === "active" ? " is-selected" : "")}>
          <input
            type="radio"
            name="listingStatus"
            value="active"
            checked={selectedStatus === "active"}
            onChange={() => handleStatusFilter("active")}
          />
          <span>Active</span>
          <span className="listing-filter__count">{listOf.filter((form) => form.AuthStatus === "active").length}</span>
        </label>
        <label className={"listing-filter listing-filter--inactive" + (selectedStatus === "inactive" ? " is-selected" : "")}>
          <input
            type="radio"
            name="listingStatus"
            value="inactive"
            checked={selectedStatus === "inactive"}
            onChange={() => handleStatusFilter("inactive")}
          />
          <span>Inactive</span>
          <span className="listing-filter__count">{listOf.filter((form) => form.AuthStatus === "inactive").length}</span>
        </label>
        <label className={"listing-filter listing-filter--upcoming" + (selectedStatus === "upcoming_books" ? " is-selected" : "")}>
          <input
            type="radio"
            name="listingStatus"
            value="upcoming_books"
            checked={selectedStatus === "upcoming_books"}
            onChange={() => handleStatusFilter("upcoming_books")}
          />
          <span>Upcoming books</span>
          <span className="listing-filter__count">{listOf.filter((form) => form.AuthStatus === "upcoming_books").length}</span>
        </label>
      </div>

      <div className="listing-catalog__results-heading">
        <div>
          <h2>Listing inventory</h2>
          <p>Product details and availability at a glance</p>
        </div>
        <span className="listing-catalog__result-count">
          Showing <strong>{filteredData.length.toLocaleString()}</strong> of {listOf.length.toLocaleString()}
        </span>
      </div>

      {filteredData.length === 0 ? (
        <div className="listing-empty">
          <span className="listing-empty__mark" aria-hidden="true">⌕</span>
          <strong>{filterText || selectedStatus ? "No matching listings" : "No listings found"}</strong>
          <p>Try a different search term or status filter.</p>
        </div>
      ) : (
        <div className="listing-table-wrap">
          <table className="listing-table">
            <thead>
              <tr>
                <th scope="col">Book listing</th>
                <th scope="col">Specifications</th>
                <th scope="col">Inventory</th>
                <th scope="col">Published</th>
                <th scope="col">Status</th>
                <th scope="col">MRP</th>
                <th scope="col"><span className="listing-table__action-heading">Action</span></th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((form, index) => {
                const status = form.AuthStatus || "unknown";
                const statusClass = status === "active"
                  ? "active"
                  : status === "inactive"
                    ? "inactive"
                    : status === "upcoming_books"
                      ? "upcoming"
                      : "unknown";
                const statusLabel = status === "upcoming_books"
                  ? "Upcoming"
                  : status === "unknown"
                    ? "Unknown"
                    : status.charAt(0).toUpperCase() + status.slice(1);
                const imageUrl = form.img
                  ? "https://d10idqgatxnd06.cloudfront.net/" + form.img
                  : "";

                return (
                  <tr key={form._id || form.sku || index}>
                    <td>
                      <div className="listing-book">
                        <div className="listing-book__preview">
                          {form.img?.toLowerCase().endsWith(".pdf") ? (
                            <embed
                              src={imageUrl}
                              type="application/pdf"
                              title={"PDF preview for " + (form.title || form.sku || "listing")}
                            />
                          ) : form.img ? (
                            <img
                              src={imageUrl}
                              alt={"Cover for " + (form.title || form.sku || "listing")}
                            />
                          ) : (
                            <span className="listing-book__placeholder" aria-label="No cover image">BK</span>
                          )}
                        </div>
                        <div className="listing-book__copy">
                          <span className="listing-book__sku">{form.sku || "SKU not set"}</span>
                          <strong title={form.title || ""}>{form.title || "Untitled book"}</strong>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="listing-specs">
                        <span className="listing-specs__medium">{form.Medium || "—"}</span>
                        <span>Edition <strong>{form.edition || "—"}</strong></span>
                      </div>
                    </td>
                    <td>
                      <div className="listing-inventory">
                        <span><strong>{form.stock ?? "—"}</strong> coins</span>
                        <span>{form.weight ?? "—"} g <small>weight</small></span>
                      </div>
                    </td>
                    <td>
                      <span className="listing-date">{form.date ? formatDate(form.date) : "—"}</span>
                    </td>
                    <td>
                      <span className={"listing-status listing-status--" + statusClass}>
                        <span className="listing-status__dot" aria-hidden="true" />
                        {statusLabel}
                      </span>
                    </td>
                    <td>
                      <strong className="listing-price">{form.mrp == null || form.mrp === "" ? "—" : "₹" + form.mrp}</strong>
                    </td>
                    <td>
                      <button
                        className="listing-edit"
                        type="button"
                        onClick={() => handleEditForm(form._id)}
                        aria-label={"Edit " + (form.title || form.sku || "listing")}
                      >
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" />
                        </svg>
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <footer className="listing-catalog__footer">
        <span>Catalog data</span>
        <span>{filteredData.length.toLocaleString()} record{filteredData.length === 1 ? "" : "s"}</span>
      </footer>
    </section>
  );
}

export default SearchFilter;
